Controller = App.loadClass 'core::Angular/Controller'

class exports.MainController extends Controller
    constructor: (@scope, @transitions, @modal) ->
        super(@scope, @transitions)

        @scope.openProfileDialog = () =>
            @modal.open
                windowClass: 'medium_dialog'
                templateUrl: 'backend/grower/profile/layout'
                controller: 'Profile.Controllers.ProfileController'
                resolve:
                    ProfileData: ['Profile.Services.ProfileService', (repo) ->
                        return repo.getProfileData()
                    ]
